import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	allCampaigns: [],
	selectedCampaign: null,
	selectedCampaignContacts: null,
};

export const dashboardCampaignManagement = createSlice({
	name: 'dashboard-campaignManagement',
	initialState,
	reducers: {
		setAllCampaigns: (state, { payload }) => ({
			...state,
			allCampaigns: payload,
		}),
		setSelectedCampaign: (state, { payload }) => ({
			...state,
			selectedCampaign: payload,
		}),
		setSelectedCampaignContacts: (state, { payload }) => ({
			...state,
			selectedCampaignContacts: payload,
		}),
		reset: () => initialState,
	},
});

export default dashboardCampaignManagement.reducer;
export const REDUCER_NAME = dashboardCampaignManagement.name;

export const { setAllCampaigns, setSelectedCampaign, setSelectedCampaignContacts, reset } =
	dashboardCampaignManagement.actions;
